import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import DesignServices from './pages/DesignServices';
import EMSSolutions from './pages/EMSSolutions';
import Manufacturing from './pages/Manufacturing';
import Industries from './pages/Industries';
import Projects from './pages/Projects';
import Contact from './pages/Contact';

function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return null;
}

function RevealOnScroll() {
  const location = useLocation();

  useEffect(() => {
    const runReveal = () => {
      const elements = document.querySelectorAll('.reveal');

      elements.forEach(el => {
        el.classList.add('visible');
      });

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
            }
          });
        },
        { threshold: 0.1 }
      );

      elements.forEach(el => observer.observe(el));

      return () => observer.disconnect();
    };

    const timer = setTimeout(runReveal, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}

function Layout() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <RevealOnScroll />
      <Navbar />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/design-services" element={<DesignServices />} />
          <Route path="/ems-solutions" element={<EMSSolutions />} />
          <Route path="/manufacturing" element={<Manufacturing />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollTop />
      <Layout />
    </Router>
  );
}